

















































































import { Component, Vue } from 'vue-property-decorator'
import TsTable from '@/components/TsTable/TsTable.vue'
import { TbData } from '@/components/TsTable/index'
import { Form } from 'element-ui'
import { saveIasGroup, fetchIasList } from '@/api/tenant/calcGroup'
import { SaveCalcGroupParams, FetchIasListPramas } from '@/types/tenant/calcGroup'
import FormItem from '@/components/formItem/index.vue'

@Component({
  name: '',
  components: {
    TsTable,
    FormItem
  }
})
export default class extends Vue {
  dialogVisible = false
  form: SaveCalcGroupParams = {
    name: '',
    type: null,
    remark: ''
  }

  dialogType = 'create'

  searchParams: FetchIasListPramas = {
    page: 0,
    size: 20
  }

  typeOptions = [
    {
      value: 'Invest',
      label: '投资规划'
    }, {
      value: 'Family',
      label: '家庭基础保障'
    }, {
      value: 'Pension',
      label: '退休规划'
    }, {
      value: 'OthersInvest',
      label: '其他-投资相关'
    }, {
      value: 'OthersRisk',
      label: '其他-潜在风险相关'
    },
    {
      value: 'OthersAllocation',
      label: '其他-分配相关'
    }
  ]

  tableData: TbData = {
    data: [],
    currentPage: this.searchParams.page,
    pageSize: this.searchParams.size,
    total: 0
  };

  tableTitleObj = {
    title: 'IAS运算组选择',
    options: {
      dropdown: false,
      arr: [
        {
          type: 'create',
          name: '新增'
        }
      ]
    }
  };

  tableHead = [
    {
      propName: 'name',
      labelName: '运算组名称',
    },
    {
      propName: 'type',
      labelName: '所属规划',
      filterBody: [
        {
          type: 'Invest',
          name: '投资规划'
        }, {
          type: 'Family',
          name: '家庭基础保障'
        }, {
          type: 'Pension',
          name: '退休规划'
        }, {
          type: 'OthersInvest',
          name: '其他-投资相关'
        }, {
          type: 'OthersRisk',
          name: '其他-潜在风险相关'
        },
        {
          type: 'OthersAllocation',
          name: '其他-分配相关'
        }
      ]
    },
    {
      propName: 'remark',
      labelName: '备注'
    },
    {
      type: 'edit',
      labelName: '操作',
      propName: 'edit',
      options: {
        dropdown: true,
        type: 'editItem',
        name: '编辑模块',
        btnType: 'text',
        arr: [
          {
            type: 'editGroup',
            name: '修改名称/分组',
            btnType: 'warning'
          },
          {
            type: 'delete',
            name: '删除'
          }
        ]
      }
    }
  ];

  tableSelectOpt = [
    {
      type: 'error',
      name: '批量删除',
      icon: 'el-icon-delete'
    },
    {
      type: 'info',
      name: '信息',
      icon: 'el-icon-info'
    }
  ];

  created () {
    this.handleSearch()
  }

  get getTitle () {
    if (this.dialogType === 'create') {
      return '新建运算组'
    } else if (this.dialogType === 'edit') {
      return '修改名称/分组'
    }
  }

  handleSearch () {
    const params = Object.assign({}, this.searchParams)
    fetchIasList(params)
      .then(res => {
        if (res.statusCode === 0 && res.data) {
          const { content, totalElements } = res.data;
          (this.tableData as TbData).data = content;
          (this.tableData as TbData).total = totalElements
        }
      })
  }

  confirm () {
    (this.$refs.calcForm as Form).validate(async valid => {
      console.log('valid', valid)
      if (valid) {
        const res = await saveIasGroup(this.form)
        if (res.statusCode === 0 && res.data) {
          this.$message({
            type: 'success',
            message: '操作成功'
          })
          this.dialogVisible = false
          this.handleSearch()
        }
      }
    })
  }

  handleTableTitleBtn (p1: string, p2: SaveCalcGroupParams) {
    console.log('p1', p1)
    console.log('p2', p2)
    if (p2) {
      switch (p1) {
        case 'editGroup':
          this.editGroup(p2)
          break
        case 'delete':
          this.delete(p2)
          break
        case 'editItem':
          this.editTableItem(p2)
          break
      }
    } else {
      this.dialogType = 'create'
      this.form = Object.assign({}, {
        name: '',
        type: null,
        remark: ''
      })
      this.dialogVisible = true
    }
  }

  handleClose () {
    this.dialogVisible = false
  }

  editGroup (data: SaveCalcGroupParams) {
    console.log('editGroup data', data)
    this.form = Object.assign({}, data)
    this.dialogType = 'edit'
    this.dialogVisible = true
  }

  async delete (data: SaveCalcGroupParams) {
    console.log('del data', data)
    const p = Object.assign(data, { deleted: true })
    const res = await saveIasGroup(p)
    if (res.statusCode === 0 && res.success) {
      this.$message.success('删除成功')
      this.handleSearch()
    }
  }

  handleSizeChange (size: number) {
    console.log('size', size)
    this.searchParams.size = size
    this.handleSearch()
  }

  handleCurrentChange (current: number) {
    this.searchParams.page = current
    this.handleSearch()
  }

  handleSelectInfo () {
    console.log('5')
  }

  editTableItem (itemData: SaveCalcGroupParams) {
    console.log('data', itemData)
    this.$router.push({
      name: 'moduleSelect',
      query: {
        id: itemData.id
      }
    })
  }
}
